const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getFormattedDate = (date: number | string | Date, format: "m,y"|"d,m,y" = "m,y", type = ""): string => {
  const d = new Date(date);

  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();

  if (format === "m,y")
    return (type === "short" ? month.substring(0, 3) : month) + ", " + d.getFullYear();
  else if (format === "d,m,y")
    return (
      d.getDate() + " " + monthNames[d.getMonth()] + ", " + d.getFullYear()
    );
  else
    return (
      monthNames[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear()
    );
};

export const getTimeAgo = (date: Date | string, shorten = false): string => {
  const formatted = new Date(date);
  const from = Date.now();

  const timeUnits = [
    { maxUnit: 60, singular: "sec", plural: "secs", short: "s" },
    { maxUnit: 60, singular: "min", plural: "mins", short: "m" },
    { maxUnit: 24, singular: "hr", plural: "hrs", short: "h" },
    { maxUnit: 30.5, singular: "day", plural: "days", short: "d" },
    { maxUnit: 12, singular: "month", plural: "months", short: "mn" },
    { maxUnit: 9999, singular: "year", plural: "years", short: "y" },
  ];

  // Get time difference in seconds to start the loop
  let timeDiff = (from - formatted.getTime())/1000;

  for (let i = 0; i < timeUnits.length; i++) {
    const { maxUnit, singular, plural, short } = timeUnits[i];
    if (timeDiff < maxUnit) {
      const timeAgo = Math.floor(timeDiff);
      return `${timeAgo}${shorten ? short : ` ${(timeAgo > 1 ? plural : singular)} ago`}`;
    }
    timeDiff /= maxUnit;
  }
  
  const formattedDate = `${formatted.getDate()}-${formatted.getMonth() + 1}-${formatted.getFullYear()}`;
  return formattedDate;
};